<!-- header -->
<sign-up-header></sign-up-header>

<div class="main-content-container">
    <div class="container-spaced">

        <div class="main-container cnt-column-centered g4Border" style="min-width: 500px">
            <div class="cnt-column-centered">
                <div [height]="15"></div>
                <div>
                    <div class="step-tittle text-align-left b4Color" i18n>{{ 'CONFIRM_YOUR' | translate }} {{isBusinessDoctors ? '' : 'Brixx'}} {{ 'Account' | translate }}</div>
                </div>
                <div [height]="10"></div>
                <div>
                    <span class="p2Font signin-text b4Color">
                        <ng-container i18n>{{ 'AN_ACTIVATION_EMAIL_HAS' | translate }} </ng-container>
                    </span>
                </div>
            </div>

            <div [height]="20"></div>

            <div class="cnt-column-centered">
                <div class="step-tittle text-align-left b4Color" style="font-weight: 600" i18n>{{email}}</div>
            </div>

            <div [height]="20"></div>

            <div class="cnt-column-centered">
                <div>
                    <span class="p2Font signin-text b4Color">
                        {{ 'PLEASE_CLICK_THE_LINK' | translate }} {{isBusinessDoctors ? '' : 'Brixx'}} {{ 'ACCUONT_IF_YOU' | translate }}
                    </span>
                </div>
                <div>
                    <span class="p2Font signin-text b4Color">
                        {{ 'CAN_NOT_SEE_THE' | translate }}
                    </span>
                </div>
            </div>

            <div [height]="10"></div>

            <div class="cnt-column-centered">
                <div>
                    <span class="p2Font signin-text b4Color" i18n>{{ 'IF_THE_EMAIL_ADDRESS_SHOWN' | translate }} </span>
                    <span class="termsLabel" (click)="goToSignUp()" i18n>{{ 'CORRECT_HERE' | translate }}</span>
                </div>
            </div>

            <div [height]="20"></div>
        </div>
    </div>
</div>